import { Autocomplete, TextField } from "@mui/material";
import React from "react";
import { HelperError, Label } from "./ShortTextInput";

//todo refactor all the input components
export const dropdownStyles = {
  "& .MuiFormControl-root": {
    // border: "1px solid #90DFEC",
    borderRadius: "8px",
    background: "var(--bg-input)",
  },
  "& .MuiOutlinedInput-root": {
    padding: "0px",
    minHeight: "45.6px",
    borderRadius: "8px",
    transition: "border-color 0.3s, box-shadow 0.3s",
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--border-input-hover)", // Border color on hover
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      outline: "none",
      borderColor: "#1976d2", // Primary color when focused
      boxShadow: "0 0 0 0.1rem rgba(25, 118, 210, 0.25)", // Add the shadow effect
    },
    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "#F40000", // Red border on error
      // boxShadow: "0 0 0 0.2rem rgba(255, 76, 76, 0.25)", // Red shadow on error
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--border-input)", // Default border color
  },
  "& .MuiAutocomplete-input": {
    padding: "10px 12px !important",
    width: "100%",
    fontSize: "14px",
  },
};

function AutoCompleteDropdown({
  label,
  required,
  options, // array of objects must have a name or value key
  value,
  error,
  placeholder,
  onChange,
  helperText,
  id,
  className,
  isOptionEqualToValue,
  filterOptions,
  onInputChange, // handle input change
}) {
  return (
    <div className={className}>
      {label && <Label id={id} required={required} label={label} />}
      <Autocomplete
        id={id}
        className="py-0"
        disablePortal
        options={options}
        value={value}
        sx={dropdownStyles}
        filterOptions={filterOptions}
        isOptionEqualToValue={isOptionEqualToValue}
        getOptionLabel={(option) => (option.name ? option.name : option.value)}
        renderInput={(params) => (
          <TextField {...params} error={error} placeholder={placeholder}/>
        )}
        onChange={onChange}
        onInputChange={onInputChange} // Handle input change
        clearOnBlur={false}
      />
      {/* Helper Text */}
      {(helperText || error) && (
        <HelperError id={id} error={error} helperText={helperText} />
      )}
    </div>
  );
}

export default AutoCompleteDropdown;
